import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { LoyaltyEarnedMeasureOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  loyaltyEarnedFromModel,
  validateLoyaltyEarnedCondition,
  type LoyaltyEarnedState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const LOYALTY_EARNED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<LoyaltyEarnedState>>,
): ConditionType<LoyaltyEarnedState, Condition.LoyaltyEarned> => ({
  name: CONDITION_NAMES[Condition.LOYALTY_EARNED],
  description(state) {
    return state.measureOption == LoyaltyEarnedMeasureOption.PERCENT
      ? t("Loyalty by {{value}} % or greater", { value: state.value })
      : t("Loyalty by {{value}} in your currency or greater", {
          value: state.value,
        });
  },
  Details(props: ConditionTypeDetailsProps<LoyaltyEarnedState>) {
    return React.createElement(Details, props);
  },
  empty: { measureOption: LoyaltyEarnedMeasureOption.PERCENT, value: 10 },
  fromModel(model: Condition.LoyaltyEarned) {
    return loyaltyEarnedFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.LOYALTY_EARNED,
      measureOption: state.measureOption,
      value: state.value,
    };
  },
  valid(state) {
    return validateLoyaltyEarnedCondition(state).valid;
  },
});
